import { createContext, useContext } from "react";
//#region src/components/Tooltip/TooltipContext.ts
/**
* The context for the Tooltip components.
*/
var TooltipContext = createContext(null);
/**
* Provides the context for the Tooltip components.
*/
function useTooltipContext() {
	const context = useContext(TooltipContext);
	if (context == null) throw new Error("Tooltip components must be wrapped in <Tooltip />");
	return context;
}
//#endregion
export { TooltipContext, useTooltipContext };

//# sourceMappingURL=TooltipContext.js.map